import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

//importing modules
import auth from './modules/auth';
import app from './modules/app';
import company from './modules/company';
import avails from './modules/avails';
import availLink from './modules/availLink';
import film from './modules/film';
import files from './modules/files';
import tag from './modules/tag';
import createMutationsSharer from 'vuex-shared-mutations';
import wishlist from './modules/wishlist';
import user from './modules/user';
import filter from './modules/filter';

Vue.use (Vuex);

export default new Vuex.Store ({
  state: {},
  actions: {
    resetAll({commit}) {
      commit ('app/reset');
      commit ('auth/reset');
      commit ('availLink/reset');
      commit ('avails/reset');
      commit ('company/reset');
      commit ('files/reset');
      commit ('film/reset');
      commit ('tag/reset');
      commit ('user/reset');
      commit ('wishlist/reset');
      commit ('filter/reset');
    },
  },
  modules: {
    auth,
    app,
    company,
    avails,
    availLink,
    film,
    files,
    tag,
    wishlist,
    user,
    filter,
  },
  plugins: [
    createPersistedState ({
      key: 'qr_avails',
    }),
    createMutationsSharer ({
      predicate: [
        //syncing only session related states
        'auth/set_key',
        'auth/set_secret',
        'app/set_session_mode',
      ],
    }),
  ],
});
